import React from 'react'
import { geolocated, GeolocatedConfig } from 'react-geolocated'
import { throttle } from 'lodash'

/**
 * @type {React.Context.<{coords: ?Coordinates, getLocation:()=>void}>}
 */
export const GeolocationContext = React.createContext({ coords: null, getLocation: () => { } })

/**
 * @type {GeolocatedConfig}
 */
const geoConfig = {
    positionOptions: {
        enableHighAccuracy: true,
    },
    watchPosition: true,
    userDecisionTimeout: 5000,
    suppressLocationOnMount: true,
}

const GeolocationObserver = geolocated(geoConfig)(({ onChange, coords }) => {
    const _onChange = React.useCallback(throttle(onChange, 1000), [onChange])
    React.useEffect(() => {
        _onChange(coords)
    }, [coords, _onChange])
    return <></>
})


function GeolocationProvider({ children, latLonSensitivity = 0.00001, speedSensitivity = 0.1 }) {
    const observerRef = React.useRef()
    const [coords, setCoords] = React.useState(null)

    const updateCoords = (nCoords) => {
        if (coords && nCoords &&
            (coords.longitude && nCoords.longitude && Math.abs(coords.longitude - nCoords.longitude) < latLonSensitivity) &&
            (coords.latitude && nCoords.latitude && Math.abs(coords.latitude - nCoords.latitude) < latLonSensitivity) &&
            (coords.speed && nCoords.speed && Math.abs(coords.speed - nCoords.speed) < speedSensitivity)
        ) {
            //no meaningful change, skip update
        } else {
            console.log('new coordinates')
            console.log(nCoords)
            setCoords(nCoords)
        }
    }

    const getLocation = () => {
        console.log("get location is called")
        console.log(observerRef.current)
        if (observerRef.current) {
            observerRef.current.getLocation()
        }
    }
    return <GeolocationContext.Provider value={{
        getLocation,
        coords,
    }}>
        <GeolocationObserver ref={observerRef} onChange={updateCoords} />
        {children}
    </GeolocationContext.Provider>
}


export default GeolocationProvider
export const GeolocationConsumer = GeolocationContext.Consumer
